const num = (value, digits = 4) => Number.isFinite(Number(value)) ? Number(value).toFixed(digits) : '?';

const seriesLabel = (series = {}) => {
  const parts = [];
  if (series.modality) parts.push(series.modality);
  if (series.seriesNumber != null && series.seriesNumber !== '') parts.push(`series ${series.seriesNumber}`);
  else parts.push('series');
  if (series.seriesDescription) parts.push(`"${series.seriesDescription}"`);
  return parts.join(' ');
};

const baseContext = (ctx = {}) => {
  const viewport = `Viewport ${(ctx.viewportIndex ?? 0) + 1}`;
  const series = seriesLabel(ctx.series || {});
  const slice = `slice ${(ctx.slice ?? 0) + 1}/${(ctx.maxSlice ?? 0) + 1}`;
  const uid = ctx.series?.seriesInstanceUID ? ` SeriesInstanceUID: ${ctx.series.seriesInstanceUID}.` : '';
  return `${viewport}, ${series}, ${slice}.${uid}`;
};

export const formatReportContextInsertion = (ctx = {}) => {
  const context = baseContext(ctx);
  if (ctx.kind === 'measurement' && ctx.measurement) {
    const m = ctx.measurement;
    const label = m.label && m.lengthLabel?.startsWith(`${m.label} (`)
      ? m.lengthLabel
      : (m.label ? `${m.label}${m.lengthLabel ? ` (${m.lengthLabel})` : ''}` : (m.lengthLabel || 'linear measurement'));
    return `Measurement: ${label}. ${context} Coordinates: A=(${num(m.a?.x)},${num(m.a?.y)}), B=(${num(m.b?.x)},${num(m.b?.y)}).`;
  }
  if (ctx.kind === 'roi' && ctx.roi) {
    const roi = ctx.roi;
    const stats = roi.stats || {};
    const statText = stats.mean !== undefined
      ? `mean ${stats.mean} HU, min ${stats.min ?? '?'}, max ${stats.max ?? '?'}, SD ${stats.sd ?? stats.std ?? '?'}`
      : 'statistics pending';
    const rx = roi.rx ?? roi.r ?? 0;
    const ry = roi.ry ?? roi.r ?? rx;
    return `ROI: ${statText}. ${context} Coordinates: center=(${num(roi.cx)},${num(roi.cy)}), rx=${num(rx)}, ry=${num(ry)}.`;
  }
  return `Key image: ${context}`;
};

export const summarizeReportContext = (ctx = {}) => {
  if (!ctx || !ctx.series) return 'No active viewport capture yet';
  if (ctx.kind === 'measurement') return `Measurement · ${baseContext(ctx)}`;
  if (ctx.kind === 'roi') return `ROI · ${baseContext(ctx)}`;
  return `Key image · ${baseContext(ctx)}`;
};
